@if (qb.loading$ | async) {
  <qb-loading style="position: fixed; width: 100%; z-index: 3000; pointer-events: none"></qb-loading>
}

<div id="loading-overlay" [class.active]="qb.loading$ | async"></div>
<!-- private -->
@if (showMaster) {
  <lausd-header (toggleSideNav)="sidenav.toggle()"></lausd-header>
  <mat-sidenav-container class="main-container">
    <mat-sidenav #sidenav mode="over" class="sidenav">
      <lausd-navigation-menu class="sidenav-mode" (click)="sidenav.toggle()"></lausd-navigation-menu>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="smd:px-2 sm:px-5 sm:pt-8">
        <div class="wrapper">
          <router-outlet></router-outlet>
        </div>
        <lausd-footer></lausd-footer>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
  @if (!landing && !qb.loading$) {
    <div>
      <lausd-footer></lausd-footer>
    </div>
  }
}

<!-- public -->

<!-- notifications -->
<qb-toast></qb-toast>
